var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"permissions",rawName:"v-permissions",value:('invoice:query'),expression:"'invoice:query'"}],staticClass:"user"},[_vm._v(" 开发中！ ")])
}
var staticRenderFns = []

export { render, staticRenderFns }